// extracted by mini-css-extract-plugin
export default {"slide":"slide_slide__cMUx9","slide_text":"slide_slide_text__2+8Lu","text":"slide_text__kjJy6","slider_img":"slide_slider_img__SxUIm"};